import { render } from "./apButton.vue?vue&type=template&id=c0504cc4&scoped=true&ts=true"
import script from "./apButton.vue?vue&type=script&lang=ts"
export * from "./apButton.vue?vue&type=script&lang=ts"

import "./apButton.vue?vue&type=style&index=0&id=c0504cc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0504cc4"]])

export default __exports__